<template lang="pug">
footer#footer.new-footer
	.section-bg-gray
		.footer-container.sfc-container
			.first-block
				.left-footer
					.new-logo
						a(href="/")
							sfc-logo-desktop.logo
				.right-footer
					.social
						p.light-font Helping families save for college since 1999

						a(href="https://www.facebook.com/Savingforcollege/" target="_blank" @click="trackAction('Footer Social Click', {'site': 'Facebook'})")
							img(:src="`${$store.state.config.s3ResourceHost}/images/redesign-v1/icons/icons-social-facebook-white.png`" alt="Facebook icon")

						a(href="https://twitter.com/saving4college" target="_blank" @click="trackAction('Footer Social Click', {'site': 'Twitter'})")
							img(:src="`${$store.state.config.s3ResourceHost}/images/redesign-v1/icons/icons-social-twitter-white.png`" alt="Twitter icon")

						a(href="https://www.linkedin.com/company/saving-for-college-llc/" target="_blank" @click="trackAction('Footer Social Click', {'site': 'Linkedin'})")
							img(:src="`${$store.state.config.s3ResourceHost}/images/redesign-v1/icons/icons-social-linked-in-white.png`" alt="Linkedin icon")

						a(href="https://www.instagram.com/saving_for_college/" target="_blank" @click="trackAction('Footer Social Click', {'site': 'Instagram'})")
							img(:src="`${$store.state.config.s3ResourceHost}/images/redesign-v1/icons/icons-social-instagram-white.png`" alt="Instagram icon")


			.second-block.dont-print
				.left-footer
					.key-resources
						p.subtitle-footer Key Resources
						.menu-footer-menu-container
							ul.menu
								li(v-for="(menu, index) of footerJson[0].children" :key="menu.id")
									a(:href="menu.url" @click="trackAction('Footer Navigation Click', {'title': `${menu.title}`})")
										| {{menu.title}}
					.our-company
						p.subtitle-footer Our Company
						.menu-footer-menu-container
							ul.menu
								li(v-for="(menu, index) of footerJson[1].children" :key="menu.id")
									a(:href="menu.url" @click="trackAction('Footer Navigation Click', {'title': `${menu.title}`})")
										| {{menu.title}}
				.right-footer
					p.subtitle-footer Join our email list
					p.newsletter
						| The latest articles and tips to help parents stay on track with saving and paying for college, delivered to your inbox every week.
					.footer-newsletter(v-if="!emailSuccess")
						.div-input.dont-print
							sfc-input(v-model="email" type="email" placeholder="Enter your email address" @input="validEmail()")
						.div-btn
							sfc-simple-button(text="Sign up" :blue="true" :medium-size="true" :square="true" :disabled="disableSubmit" @click="submitEmail()")
					.message(v-if="emailSuccess")
						| Thank you! You have been successfully subscribed to our email list.

					.featured-in
						p.subtitle-footer
							| Frequently featured in
						press-logos-desktop.press-logos-desktop
						press-logos-mobile.press-logos-mobile

			.centered-featured-in.dont-print
				p.subtitle-footer
					| Frequently featured in
				press-logos-tablet

			.third-block.dont-print
				.mission
					p
						| Saving For College is an unbiased, independent resource for parents and financial professionals, providing them with information and tools to understand the benefits of 529 college savings plans and how to meet the challenge of increasing college costs.

	.section-bg-dark-gray
		.footer-container.sfc-container
			.left-footer
				.copyright
					p Copyright &copy; {{(new Date()).getFullYear()}} Saving for College, LLC.
				.rights
					p All Rights Reserved
			.right-footer
				.address
					p 20533 Biscayne Blvd Ste 4 #199 Miami, FL 33180-1501
				.phone
					p
						span
							| Phone:&nbsp;
							a(href="tel:+1-585-286-5426") (585) 286-5426
</template>

<style lang="stylus">
	@import '~assets/css/redesign-v1/variables.styl'

	footer
		.section-bg-gray
		.section-bg-dark-gray
			.footer-container
				display: flex
				flex-wrap: wrap
				max-width: 1176px
				margin: auto
				position: relative
				&.sfc-container
					width: 100%
					@media (max-width: 767px)
						padding: 0 16px
					@media (min-width: 768px) and (max-width: 1199px)
						padding: 0 24px
					@media (min-width: 1200px) and (max-width: 1499px)
						width: 90%
					@media (min-width: 1500px)
						width: 70%

		.section-bg-gray
		.section-bg-dark-gray
			.left-footer
			.right-footer
				width: 50%
				display: flex
				flex-wrap: wrap

		.section-bg-gray
			.left-footer
			.right-footer
				@media(max-width: 575px) // 767
					width: 100%

		.section-bg-gray
			background: footer-grey
			.first-block
				padding: 56px 0 48px
				width: 100%
				display: flex
				flex-wrap: wrap
				border-bottom: 1px solid gray-70
				@media (max-width: 575px)
					padding: 48px 0 24px

			.first-block
				.left-footer
					.new-logo
						@media(max-width: 575px) // 767
							width: 100%
							text-align: center
						.logo
							width: 216px
							height: 80px
				.right-footer
					.social
						@media(max-width: 575px) // 767
							width: 100%
							text-align: center
						p
							font-size: body-font-size-md + 2
							color: #fff
							letter-spacing: 0
							margin-bottom: 18px
							font-weight: 300
							line-height: normal
							@media(max-width: 575px) // 767
								width: 70%
								margin: 24px auto
						a
							margin-right: 16px
							@media(max-width: 991px)
								margin-right: 40px
								&:last-of-type
									margin-right: 0
							img
								width: 32px
								height: 32px
			.second-block
				width: 100%
				display: flex
				flex-wrap: wrap
				align-items: flex-start
				border-bottom: 1px solid gray-70
				padding: 32px 0 48px
				@media(max-width: 575px)
					padding: 24px  0 32px
				@media(min-width: 576px) and (max-width: 991px)
					padding: 32px 0

				.left-footer
					.key-resources
						width: 50%
					.our-company
						width: 50%
						@media(min-width: 576px) and (max-width: 680px)
							width: calc(50% - 16px)
							margin-left: 16px
					.key-resources
					.our-company
						ul
							padding-left: 0
							margin-bottom: 0
							li
								list-style: none
								padding-bottom: 16px
								&:last-of-type
									padding-bottom: 0px
								a
									text-decoration: none
									font-size: body-font-size-md
									color: gray-30
									line-height: normal
									&:hover
										color: #fff

				.right-footer
					p.subtitle-footer
						margin-bottom: 14px
						@media(max-width: 575px) // 767
							margin-top: 48px
					.newsletter
						font-size: body-font-size-md
						color: gray-30
						line-height: body-font-line-heigth-md
						font-weight: body-font-light
						margin-bottom: 24px
						@media(max-width: 991px)
							margin-bottom: 16px
					.footer-newsletter
						width: 100%
						display: flex
						flex-wrap: wrap
						.div-input
							width: 70%
							margin-bottom: 16px
							@media(max-width: 991px)
								width: 100%
							.input-v4
								input
									max-height: 44px
									@media(max-width: 575px) // 767
										max-width: 343px
						.div-btn
							width: 28%
							margin-left: 8px
							@media(max-width: 991px)
								margin-left: 0
							.sfc-simple-button
								min-width: 130px
								@media(max-width: 991px)
									width: 163px
					.message
						width: 100%
						color: gray-30
						font-size: body-font-size-md
						margin-bottom: 16px
						font-weight: body-font-light

					.centered-featured-in
					.featured-in
						width: 100%
						margin-top: 24px
						p.subtitle-footer
							margin-bottom: 24px

					.featured-in
						display: flex
						flex-wrap: wrap
						@media(max-width: 575px) // 767
							display: block
							margin-top: 32px
							border-top: 1px solid gray-70
							text-align: center
						@media(min-width: 576px) and (max-width: 991px)  // 768
							display: none
						.press-logos-desktop
							display: block
							@media(max-width: 575px) // 767
								display: none
						.press-logos-mobile
							display: none
							@media(max-width: 575px) //767
								display: block
								margin: 0 auto
						p.subtitle-footer
							@media(max-width: 575px) // 767
								margin-top: 32px


			.centered-featured-in
				width: 100%
				padding: 32px 0
				text-align: center
				border-bottom: 1px solid gray-70
				display: none
				@media(min-width: 576px) and (max-width: 991px) // 768
					display: block
				p.subtitle-footer
					margin-bottom: 24px

			.third-block
				padding: 32px 0 42px
				@media(max-width: 575px)
					padding: 24px 0 22px
				@media(min-width: 576px) and (max-width: 991px)
					padding: 32px 0 32px
				.mission
					width: 50%
					@media(max-width: 991px)
						width: 100%
					p
						font-size: body-font-size-md
						color: gray-30
						line-height: body-font-line-heigth-md
						font-weight: body-font-light
						margin-bottom: 0

			p.subtitle-footer
				width: 100%
				font-size: body-font-size-md + 2
				color: #fff
				font-weight: body-font-weight-medium
				line-height: normal
				margin-bottom: 16px

		.section-bg-dark-gray
			background: footer-black
			padding: 32px 0
			@media(max-width: 991px)
				padding: 24px 0
			.left-footer
			.right-footer
				@media(max-width: 600px)
					width: 100%
			p
				font-size: body-font-size-sm - 1
				color: gray-50
				line-height: normal
				margin-bottom: 0
				a
					color: gray-50
					text-decoration: none
					&:hover
						color: #fff
			.copyright
			.rights
			.address
			.phone
				@media(max-width: 991px)
					width: 100%

			.rights
				margin-left: 5px
				@media(max-width: 991px)
					margin-left: 0
					margin-top: 16px
			.address
				@media(max-width: 600px)
					margin-top: 16px
				@media(min-width: 992px)
					margin-top: 0
			.phone
				margin-left: 27px
				@media(max-width: 991px)
					margin-left: 0
					margin-top: 16px
				@media(min-width: 992px)
					margin-top: 0
</style>

<script>
import SfcLogoDesktop from '@/common/components/icons/redesign-v1/sfc-logo-desktop'
import MenuJSON from '@/menu-footer.json'
import PressLogosDesktop from '@/common/components/icons/redesign-v1/press-logos-desktop'
import PressLogosTablet from '@/common/components/icons/redesign-v1/press-logos-tablet'
import PressLogosMobile from '@/common/components/icons/redesign-v1/press-logos-mobile'
import SfcInput from '@/common/components/inputs/redesign-v1/textbox'
import SfcSimpleButton from '@/common/components/redesign-v1/sfc-simple-button'
import SfcTrackingService from "@/lib/sfc-tracking-service"

export default {

	components: {
		SfcLogoDesktop,
		MenuJSON,
		PressLogosDesktop,
		PressLogosTablet,
		PressLogosMobile,
		SfcInput,
		SfcSimpleButton
	},
	data(){
		return {
			showSubmit: false,
			disableSubmit: true,
			email: "",
			emailError: false,
			emailErrorMessage: "",
			emailSuccess: false,
			footerJson: MenuJSON['footer'],
			refreshInterval: null,
		}
	},
	methods: {
		trackAction(eventDescription, additionalInformation = false){
			SfcTrackingService.trackAction(eventDescription, "Footer", "2", additionalInformation)
		},
		validEmail(){
			const regex = /^(([^<>()\[\]\\.,;:\s@“]+(\.[^<>()\[\]\\.,;:\s@“]+)*)|(“.+“))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			if (!regex.test(this.email)) {
				this.emailError = true
				this.disableSubmit = true
			}else{
				this.disableSubmit = false
			}
			return !this.emailError
		},
		async submitEmail() {
			this.trackAction('Join email list')

			const query =
				`
				mutation{
					track_data(email: "${this.email}", email_source: "footer", source: "footer", campaign: "newsletters", consumer_newsletter: "Yes")
				}
				`
			try {
				await this.$httpService.graphql(query)
				if (heap) {
					heap.addUserProperties({"email": this.email})
				}
			} catch (e) {
				console.log("fail")
			}
			this.emailSuccess = true
		},
		startAdRefresh() {
			const visibleSlots = new Set();

			googletag.cmd.push(() => {
				googletag.pubads().addEventListener('slotVisibilityChanged', function (event) {
					// If slot is at least 80% visible, we want to refresh it.
					if (event.inViewPercentage >= 80) {
						visibleSlots.add(event.slot)
					} else {
						visibleSlots.delete(event.slot)
					}
				})
			})

			// Refresh every 30 seconds, but only for slots that meet threshold.
			setInterval(() => {
				if (visibleSlots.size > 0) {
					googletag.cmd.push(() => {
						googletag.pubads().refresh(Array.from(visibleSlots))
					})
				}
			}, 30000)
		},
		stopAdRefresh() {
			if (this.refreshInterval) {
				clearInterval(this.refreshInterval);
				this.refreshInterval = null;
			}
		},
		
	},
	mounted() {
		this.startAdRefresh();
	},
	beforeDestroy() {
		this.stopAdRefresh();
	},
}
</script>
